// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.taskactivitiygroup > * {
    margin-left: 7px;
    margin-bottom: 4px;
}
.tasksettingsreportobject{
    margin-top: 11px;
}
`, "",{"version":3,"sources":["webpack://./src/app/workflow/modules/settaskactivity/set.task.activity.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,kBAAkB;AACtB;AACA;IACI,gBAAgB;AACpB","sourcesContent":[".taskactivitiygroup > * {\n    margin-left: 7px;\n    margin-bottom: 4px;\n}\n.tasksettingsreportobject{\n    margin-top: 11px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
